<template>
    <div class="notFond-comp">
        <img src="//s.thsi.cn/webprivate/pcnews/2.0/img/404.png">
    </div>
</template>

<script>
export default {
    name: '',
    data() {
        return {}
    },
}
</script>
<style lang="less" scoped>
.notFond-comp {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    > img {
        width: 200px;
        height: 200px;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
    }
}
</style>
